<template>
  <div class="short-answer" :id="item.questionId">
    <p class="iv-fs-16 iv-fc-85 iv-p-t-16 iv-p-b-16 iv-fw-6">
      <span v-if="item.isRequire == 1" style="color: red">* </span>
      [简答题]&nbsp;{{index + 1}}.&nbsp;{{item.questionName}}
    </p>
    <div
    v-if="item.optionList.length > 0"
    v-for="(i, index) in item.optionList"
    :key="i.optionId + index">
      <p class="iv-fs-14 iv-fc-85 iv-p-t-16 iv-p-b-8" v-if='i.optionInfo'>{{i.optionOrder}} {{i.optionInfo}}</p>
      <Input
      class="iv-textarea-color"
      v-model="i.userAnswer"
      @on-blur="change(item)"
      type="textarea"
      :autosize="{minRows: 5,maxRows: 5}"
      :maxlength="item.isRestrictedNum==1?item.wordNum:1000"
      placeholder="请输入作答内容"
      :disabled="state != 1"></Input>
    </div>
    <div v-if="item.optionList.length == 0">
      <Input
      class="iv-textarea-color"
      v-model="item.userAnswer"
      @on-blur="change(item)"
      type="textarea"
      :autosize="{minRows: 5,maxRows: 5}"
      :maxlength="item.isRestrictedNum==1?item.wordNum:1000"
      placeholder="请输入作答内容"
      :disabled="state != 1"></Input>
    </div>
  </div>
</template>
<script>
export default {
  props: ['item', 'index'],
  data () {
    return {
      state: 0
    }
  },
  computed: {
    isRequire () {
      return this.item.isRequire == 1 ? '[必填]' : ''
    }
  },
  created () {
    this.state = this.$route.query.state
  },
  methods: {
    change (item) {
      //判断是否作答
      //传递答案
      if (this.item.optionList.length > 0) {
        for (let it of this.item.optionList) {
          if (it.userAnswer) {
            this.$emit('change', item, this.index, true)
            return
          }
        }
        this.$emit('change', this.item, this.index, false)
      } else {
        if (this.item.userAnswer) {
          this.$emit('change', this.item, this.index, true)
        } else {
          this.$emit('change', this.item, this.index, false)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
<style lang="scss">
.short-answer{
  border-bottom:1px solid rgba(0,0,0,0.09);
  textarea{
    resize: none;
    color: #555!important;
  }
}
</style>
